import type { User } from "@version2/domain-package";

export type UserDocState = Record<string, unknown> & {
	userDoc?: User | null;
};

export type UserDocSelector = (state: UserDocState) => User | null;

export const defaultUserDocSelector: UserDocSelector = (state) => state.userDoc ?? null;

export type StringFieldData = {
	multiline?: boolean;
  maxLength?: number;
  rows?: number;
};

export type ListFieldData = {
	singular_name?: string;
	plural_name?: string;
	item_name_id?: string;
};

export type FieldData = Record<string, unknown>;
